module.exports = __webpack_public_path__ + "static/CTA-7e9e3cfb7e3f7bd1573343ded1174a39.png";